var map = {
	"./alipay.svg": "0ad5",
	"./american-express.svg": "46f6",
	"./diners-club.svg": "11c5",
	"./discover.svg": "f3db",
	"./elo.svg": "8240",
	"./hipercard.svg": "1f06",
	"./jcb.svg": "4096",
	"./maestro.svg": "92ad",
	"./mastercard-old.svg": "c585",
	"./mastercard.svg": "cc26",
	"./unionpay.svg": "544c",
	"./visa.svg": "5cda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b67";